import * as React from "react";
import NumberVisualization from "views/components/visualizations/number/NumberVisualization";
import NumberVisualizationConfig from "views/logic/aggregationbuilder/visualizations/NumberVisualizationConfig";
const singleNumber = {
  type: NumberVisualization.type,
  displayName: "Single Number",
  component: NumberVisualization,
  config: {
    fromConfig: (config) => ({
      trend: config == null ? void 0 : config.trend,
      trend_preference: config == null ? void 0 : config.trendPreference
    }),
    toConfig: ({ trend = false, trend_preference }) => NumberVisualizationConfig.create(trend, trend_preference),
    fields: [
      {
        name: "trend",
        title: "Trend",
        type: "boolean",
        description: "Show trend information for this number.",
        helpComponent: () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "If the user enables trending, a separate box is shown below the current value, indicating the direction of the change by an icon as well as the absolute and the relative differences between the current value and the previous one."), /* @__PURE__ */ React.createElement("p", null, "The previous value is calculated by performing two searches in the background, which are completely identical besides the timerange. The timerange of the first search is identical to the one configured for this query/this widget, the second one is the same timerange, but with an offset of the timerange length shifted to the past."))
      },
      {
        name: "trend_preference",
        title: "Trend Preference",
        type: "select",
        options: [
          ["Lower", "LOWER"],
          ["Neutral", "NEUTRAL"],
          ["Higher", "HIGHER"]
        ],
        required: true,
        isShown: (formValues) => (formValues == null ? void 0 : formValues.trend) === true
      }
    ]
  }
};
export default singleNumber;
